<template>
  <div id="app" >
    <router-view></router-view>
    <div class="gootbox">
      <div class="goot">
        <div class="top">
          <div class="text">关于我们</div>
          <!-- <div class="img img1"></div>
          <div class="img img2"></div> -->
        </div>
        <div class="goot2box">
          <div class="goot2">
            <div class="goot2text goot2text1">产品</div>
            <div @click="fuwu" class="goot2text goot2text2">产品服务</div>
            <div @click="cpgyl" class="goot2text goot2text3">1折爆品供应链</div>
            <div @click="sxy" class="goot2text goot2text4">商学院 - 你的营销生意经</div>
            <div @click="cpgyl" class="goot2text goot2text5">掌握营销大数据</div>
          </div>
          <div class="goot2">
            <div class="goot2text goot2text1">&nbsp;</div>
            <div @click="cpgyl" class="goot2text goot2text2">免费Saas营销商城</div>
            <div @click="cpgyl" class="goot2text goot2text3">裂变营销工具</div>
            <div @click="cpgyl" class="goot2text goot2text4">精准到店引流</div>
          </div>
          <div class="goot2">
            <div class="goot2text goot2text1">企业介绍</div>
            <div @click="gywm" class="goot2text goot2text2">关于我们</div>
          </div>
          <div class="goot2 goot2style">
            <div class="goot2text goot2text1">河北米创电子科技有限公司</div>
            <div class="goot2text goot2text2">
              地址：深圳湾（保定）创新中心
            </div>
            <div class="goot2text goot2text3">电话：400 - 105 6888</div>
            <div class="goot2text goot2text4">邮箱：michuang_321@foxmail.com</div>

          </div>
          <div class="goot2right">
            <div class="img img1"></div>
            <div class="textbox">
              <div class="rwm">
                <div class="img1"></div>
                <div class="text1">官方服务号</div>
              </div>
              <!-- <div class="rwm">
                <div class="img2"></div>
                <div class="text1">商E通APP</div>
              </div> -->
            </div>
          </div>
        </div>
        <div style="width: 100%; text-align: center; padding-bottom: 0.2rem">
          © 2009 - 2020 aone . 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">冀ICP备17028149号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    //
    return {
      hsk:1
    };
  },

  mounted() {
    
  },
  methods: {
     ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>

<style lang="scss">
html {
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
}
/*Chrome下隐藏滚动条，溢出可以透明滚动*/
*::-webkit-scrollbar {
  width: 0px;
}
* {
  word-break: break-all;
  font-family: "Adobuheiti HeitiStd-Regular";
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-align: left;
  // overflow: hidden scroll;
  font-size: 0.14rem;
}
html,
body,
#app {
  height: 100%;
  // overflow: hidden;
}
li {
  list-style: none;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  // object-fit: contain;
}
button {
  outline: none;
  cursor: pointer;
  border: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fl {
  float: left;
}

.fr {
  float: right;
}
/*  清除浮动  */

.clearfix:after {
  content: " ";
  display: block;
  clear: both;
  visibility: hidden;
}
.br {
  border: 1px solid red;
}

//
.dhtBox {
  height: 0.98rem;
  background: url("../src/assets/images/1908.png");
  background-size: 100% 100%;
  display: flex;
  position: relative;
  // top: 0;
  z-index: 9999999;
  .logo {
    width: 2.24rem;
    height: 0.59rem;
    background: url("../src/assets/images/logo.png");
    background-size: 100% 100%;
    margin-right: 0.8rem;
  }
  .cdBox {
    width: 1200px;
    height: 0.98rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .cd {
      margin-left: 0.39rem;
      margin-right: 0.39rem;
      font-size: 0.14rem;
      color: #fffefe;
      border-bottom: 2px solid transparent;
      padding-bottom: 0.1rem;
      position: relative;
      cursor: pointer;
      .yddxiazai {
        width: 2.65rem;
        height: 1.18rem;
        background: #ffffff;
        border-radius: 0.1rem;
        position: absolute;
        bottom: -1.3rem;
        left: -1rem;
        z-index: 999999;
        display: flex;
        // height: 0;
        overflow: hidden;
        .hezi {
          width: 33.3%;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          .img {
            width: 0.6rem;
            height: 0.6rem;
            background: #000;
            margin-top: 0.15rem;
          }
          .text {
            font-size: 0.15rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #191919;
          }
        }
      }
    }
    .cd_style {
      border-bottom: 2px solid #fff;
    }
    .cd:hover {
      border-bottom: 2px solid #fff;
    }
    // .cd:hover > .yddxiazai {
    //   height: 1.18rem;
    // }
    // .cd:nth-child(7){
    //   display: none;
    // }
    
  }
}

.BMap_cpyCtrl, .anchorBL {
      display: none;
}
.gootbox {
    width: 100%;
    background: #fbfbfb;
    .goot {
      width: 1200px;
      margin: 0 auto;
      .top {
        height: 1rem;
        display: flex;
        justify-content: left;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 0.3rem;
        .text {
          font-size: 0.25rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #5f6364;
          margin-right: 0.6rem;
        }
        .img {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.49rem;
        }
        .img1 {
          background: url("../src/assets/images/wx1.png");
        }
        .img1:hover {
          background: url("../src/assets/images/wx2.png");
        }
        .img2 {
          background: url("../src/assets/images/wb1.png");
        }
        .img2:hover {
          background: url("../src/assets/images/wb2.png");
        }
      }
      .goot2box {
        display: flex;
        flex-flow: wrap;
        padding-bottom: 0.8rem;
        .goot2 {
          margin-right: 0.55rem;
          margin-top: 0.3rem;
          .goot2text {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #7f7f7f;
            margin-bottom: 0.2rem;
            cursor: pointer;
          }
          .goot2text:hover {
            color: #2d60fe;
          }
          .goot2text1 {
            font-size: 0.25rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #474747;
            margin-bottom: 0.45rem;
          }
          .goot2text2 {
          }
          .goot2text3 {
          }
          .goot2text4 {
          }
          .goot2text5 {
          }
        }
        .goot2style {
          margin-right: 0.35rem;
        }
        .goot2right {
          width: 3.2rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;  

          box-sizing: border-box;
          .img {
            width: 2.04rem;
            height: 0.83rem;
            background: url("../src/assets/images/867.png") no-repeat center;
            background-size: 100% ;

            // margin-bottom: 0.4rem;
          }
          .textbox {
            // width: 3.11rem;
            height: 1.43rem;
            background: #ffffff;
            border-radius: 20px;
            display: flex;
            .rwm {
              // width: 50%;
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              padding-top: 0.15rem;
              .img1 {
                width: 0.77rem;
                height: 0.77rem;
                background: url("../src/assets/images/85c3e9280f99ad7a53a06a60079ff75.jpg")
                  no-repeat center;
                background-size: 100% 100%;
              }
              .img2 {
                width: 0.77rem;
                height: 0.77rem;
                background: #000;
              }
              .text1 {
                font-size: 0.14rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #191919;
                width: 100%;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue